var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTilesViewPlantsDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.5L19.1 5.25C19.48 4.776 20.054 4.5 20.662 4.5H28.34C28.948 4.5 29.522 4.776 29.902 5.25L32.5 8.5V10.5C32.5 11.604 31.604 12.5 30.5 12.5H18.5C17.396 12.5 16.5 11.604 16.5 10.5V8.5V8.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 24.5V12.5C40.5 10.29 38.71 8.5 36.5 8.5H32.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.5H12.5C10.29 8.5 8.5 10.29 8.5 12.5V38.5C8.5 40.71 10.29 42.5 12.5 42.5H24.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0331 37.882C29.4851 37.05 29.4851 35.954 30.0331 35.122C31.7291 32.556 34.3931 30.5 37.0591 30.5C39.7251 30.5 42.3871 32.556 44.0851 35.12C44.6351 35.952 44.6351 37.05 44.0851 37.88C42.3851 40.444 39.7231 42.5 37.0591 42.5C34.3931 42.502 31.7291 40.446 30.0331 37.882V37.882Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3292 35.2512C37.6153 34.5214 36.4838 34.5656 35.8055 35.232L35.796 35.2413C35.0983 35.9391 35.0983 37.0669 35.796 37.7647C36.4938 38.4625 37.6216 38.4625 38.3194 37.7647C39.0139 37.0702 39.0171 35.9497 38.3292 35.2512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.5H32.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32.5H20.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilesViewPlantsDetails);
export default __webpack_public_path__ + "static/media/tiles-viewPlantsDetails.c495a7c20c313ec822a3193dd2d38473.svg";
export { ForwardRef as ReactComponent };